import {post, download, get} from './apiUtils';

const defaultUrl = '/Documents/';

export default {
  saveDocument: data => post(defaultUrl, data),
  downloadDocument: (documentId, fileName) => download(`${defaultUrl}${documentId}/Download`, fileName),
  getDocumentBytes: id => get(`${defaultUrl}${id}/GetBytes`),
};
